var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[(_vm.showIcon)?_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":_vm.onClick},slot:"activator"},[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("share")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Share")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d77ceaa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/NoteShare.vue
// module id = 173
// module chunks = 1